module.exports = __webpack_public_path__ + "@/assets/img/fotty_square.bd98990d.jpg";